import { Spinner } from '@tempmee/react';
import { Suspense } from 'react';
import { Center } from '~/commonComponents';
import { PDFPreviewConsent } from '~/commonComponents/PDFPreviewConsent';

export const SignUpTermsAndConditions = ({
  handleAccept,
  pdfUrl,
  isLoading,
}: {
  handleAccept: () => void;
  pdfUrl: string;
  isLoading: boolean
}) => {
  return (
    <Suspense
      fallback={
        <div className="component_container">
          <div
            className="floating_container"
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              marginInline: '20px',
            }}
          >
            <Center marginTop={40}>
              <Spinner centered variant="default" size="md" />
            </Center>
          </div>
        </div>
      }
    >
      <PDFPreviewConsent
        pdfUrl={pdfUrl}
        isAccepting={false}
        isLoading={isLoading}
        onConsent={handleAccept}
        minHeight={'100vh'}
      />
    </Suspense>
  );
};
